import { render, staticRenderFns } from "./PetProfile.vue?vue&type=template&id=2782c268&scoped=true&"
import script from "./PetProfile.vue?vue&type=script&lang=js&"
export * from "./PetProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2782c268",
  null
  
)

export default component.exports